import { useCallback, useContext } from 'react';

import {
  ErrorFromBack,
  getUniqueBuiltErrorNotifications,
  MessageDescriptorMap,
} from '../../../../helpers/errorsMessage';
import { isNetworkErrorWhileOffline } from '../helpers/isNetworkErrorWhileOffline';
import ToastsContext from '../ToastsProvider.context';

export type UsePushErrorReturnType = (error: Error | ErrorFromBack) => void;

interface UsePushErrorArgs {
  extendedMessages?: MessageDescriptorMap;
}

const usePushError = ({ extendedMessages }: UsePushErrorArgs = {}) => {
  const { pushNotifications } = useContext(ToastsContext);

  return useCallback(
    (error: Error | ErrorFromBack) => {
      if (isNetworkErrorWhileOffline(error)) {
        return;
      }

      const toasts = getUniqueBuiltErrorNotifications({
        errors: [error],
        extendedMessages,
      });

      pushNotifications(toasts);
    },
    [extendedMessages, pushNotifications],
  );
};

export default usePushError;
